import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { ManualPaymentModalComponent } from './manual-payment-modal.component';
import { ManualPaymentModalRoutingModule } from './manual-payment-modal-routing.module';
import { ManualPaymentModalResolve } from './manual-payment-modal.resolve';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    ManualPaymentModalRoutingModule,
    MatDialogModule,
  ],
  declarations: [ManualPaymentModalComponent],
  entryComponents: [],
  exports: [ManualPaymentModalComponent],
  providers: [ManualPaymentModalResolve],
})
export class ManualPaymentModalModule {}
